window.GobiertoParticipation = {
  init: function() {}
};

$(document).ready(function() {
  return GobiertoParticipation.init();
});
